'use client'

import { useEffect, useRef, useState } from "react"
import { initArmsRum, setArmsUser } from "@/vendor/arms"
import { useUserStore } from "@/store/useUserStore"
import { useCookieConsentStore } from "@/store/useCookieConsentStore"
import { runWhenIdle } from "@/util/dom"

// 同意状态持久化在 cookie，由 zustand persist 异步水合。水合完成前 store 是默认值
// （opt-out 策略下 analytics 默认 true）。必须等水合完成后再决定是否初始化 ARMS，
// 否则会用「默认 true」给曾拒绝（水合后为 false）的用户错误初始化上报。
const useConsentHydrated = () => {
  const [hydrated, setHydrated] = useState(() => useCookieConsentStore.persist.hasHydrated())
  useEffect(() => {
    const unsub = useCookieConsentStore.persist.onFinishHydration(() => setHydrated(true))
    if (useCookieConsentStore.persist.hasHydrated()) setHydrated(true)
    return unsub
  }, [])
  return hydrated
}

export const ArmsRum = () => {
  const userId = useUserStore(state => state.userId)
  // 性能/错误监控属于分析类 cookie，仅在用户同意后启用
  const analyticsConsent = useCookieConsentStore(state => state.analytics)
  const hydrated = useConsentHydrated()

  useEffect(() => {
    // 水合完成前不动作，避免用默认值误初始化；同意时才初始化（内部保证只初始化一次）。
    // 注意：撤回同意不再刷新页面（ARMS SDK 无运行时停止接口，本次会话内会继续上报，
    // 下次进入页面时因未同意而不再初始化即停止），以避免刷新带来的体验问题。
    if (!hydrated || !analyticsConsent) return
    // SDK 加载 + init 是百毫秒级长任务，挪到 load 后空闲时执行；
    // Web Vitals 走 buffered PerformanceObserver，推迟初始化不丢 LCP/CLS
    return runWhenIdle(() => { initArmsRum() })
  }, [analyticsConsent, hydrated])

  useEffect(() => {
    if (!hydrated || !analyticsConsent) return
    // setArmsUser 内部会触发 init，需同样推迟
    return runWhenIdle(() => { setArmsUser(userId) })
  }, [userId, analyticsConsent, hydrated])

  return null
}
